// src/lib/partnerLookup.js
//
// Firm-name lookups. The browser can no longer read the `partners` table
// directly (supabase/migrations/019). These wrap the two SECURITY DEFINER
// functions from supabase/migrations/018 that return the firm NAME only.
// The RPC names live only here.

import { supabase } from './supabase'

// Anonymous ?ref= pages. Returns { data: { name } | null, error }.
export async function fetchPartnerNameByRef(refSlug) {
  const { data, error } = await supabase.rpc('get_partner_name_by_ref', { p_ref_slug: refSlug })
  return { data: data ? { name: data } : null, error }
}

// Signed-in user's own firm. Returns { data: string | null, error }.
export async function fetchMyFirmName() {
  const { data, error } = await supabase.rpc('get_my_firm_name')
  return { data: data || null, error }
}
